import { render, staticRenderFns } from "./page-result-view.vue?vue&type=template&id=f70e6094&scoped=true&"
import script from "./page-result-view.vue?vue&type=script&lang=js&"
export * from "./page-result-view.vue?vue&type=script&lang=js&"
import style0 from "./page-result-view.vue?vue&type=style&index=0&id=f70e6094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70e6094",
  null
  
)

export default component.exports